import React, { useEffect, useState }  from 'react'
import DGTextarea from "components/FormControls/Textarea/DGTextarea";
import { Dimmer, Modal, Loader, Grid } from "semantic-ui-react";
import { saveSellerDetail } from 'services/Seller';
import Formsy from "formsy-react";

export default function SellerAdditionalInfo(props) {

    
    const [savingSellerInfo, setSavingSellerInfo] = useState(false);
    const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState('');

    useEffect(() => {
        console.log(props)
        setSelectedAdditionalInfo(props.additionalInfo)
    }, [props.additionalInfo]);


    const onSellerInfoModalClose = () => {
        if(props.close){
            props.close();
        }
    }

    const onValidSellerInfoSave = async () => {
        const res = await saveSellerDetail(props.sellerID, {additionalInfo : selectedAdditionalInfo});
        if(res && res.resStatus == 200)
        {
            if(props.refreshList){
                props.refreshList();
            }
            
            if(props.close){
                props.close();
            }
        }
        else
        {
            setMessage(res.message);
        }
    }
    
    const onAdditionalInfoChange = (e, data) => {
        setSelectedAdditionalInfo(data.value);
    }
  return (
    <Modal className="seller-info-modal-container"
                    closeOnDimmerClick={false}
                    closeOnEscape={false}
                    onClose={onSellerInfoModalClose}
                    open={props.open}
                    closeIcon>
                    <Modal.Header className="sellerInfo-modal-header">
                        {props.sellerName}
                    </Modal.Header>
                    <Dimmer.Dimmable as={Modal.Content} blurring dimmed={savingSellerInfo}>
                        <Dimmer active={savingSellerInfo} inverted>
                            <Loader>Saving</Loader>
                        </Dimmer>
                        <Formsy onValidSubmit={onValidSellerInfoSave}>

                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <DGTextarea
                                            name="additionalInfo"
                                            value={selectedAdditionalInfo}
                                            maxLength={512}
                                            label="Additional Details"
                                            onChange={onAdditionalInfoChange} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <button className="button-submit">Save</button>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Formsy>
                    </Dimmer.Dimmable>
                </Modal>
  )
}
